function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "interface");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1005.000000, -244.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(338.000000, 75.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.000000, 137.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-Buttons-/-2.-Medium-/-Icon-Copy",
  transform: "translate(632.000000, 21.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.88085431,2.67935367 L1.07742681,11.4834157 C1.03313684,11.5278326 1.00115668,11.5839248 0.985928031,11.6442048 L0.0101524319,15.5607592 C-0.019035826,15.6786543 0.0156093721,15.8040369 0.101651216,15.8900787 C0.166753677,15.9551812 0.255460559,15.9912223 0.346197926,15.9912223 C0.373990217,15.9912223 0.402417026,15.9877959 0.430082387,15.9808161 L4.3466368,15.0049136 C4.40767829,14.9896849 4.46313594,14.9578317 4.50742595,14.9135417 L13.3116149,6.11011422 L9.88085431,2.67935367 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.492611,1.47895553 L14.5126476,0.498992026 C13.8576888,-0.155966726 12.7161747,-0.155332207 12.0619774,0.498992026 L10.8615792,1.6993902 L14.2922128,5.13002382 L15.492611,3.92962565 C15.8197731,3.60259045 15.9999788,3.16730495 15.9999788,2.70435405 C15.9999788,2.24140316 15.8197731,1.80611763 15.492611,1.47895553 Z"
}))))))));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.531d6184.svg";
export { ForwardRef as ReactComponent };